export const HEADER_HEIGHT = 65;
export const DRAWER_HEIGHT = 240;

export const LIST_BREAKPOINTS = {
  lg: 3,
  md: 4,
  sm: 6,
  xs: 12,
};
